<script setup lang="ts">
    import { computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import { isNullOrWhitespace } from '@common/Common'
    import { guid } from '@common/Guid'
    import { useCreateStrategyCommandV1 } from '@Quest/Strategies/commands-vue-composables'
    import { useStrategyByWorkspaceIdQueryV1 } from '@Quest/Strategies/queries-vue-composables'
    import { StrategyReadModel } from '@Quest/Strategies/readmodels'

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))

    const {
        runStrategyByWorkspaceIdQueryV1,
        modelStrategyByWorkspaceIdQueryV1
    } = useStrategyByWorkspaceIdQueryV1(workspaceId)

    const {
        invokeCreateStrategyCommandV1,
        invokingCreateStrategyCommandV1,
        errorCreateStrategyCommandV1,
        succeedCreateStrategyCommandV1
    } = useCreateStrategyCommandV1(workspaceId, () => guid(), "Strategy", "")

    onMounted(() =>
    {
        document.title = "Strategy | TransparentChoice";
        runStrategyByWorkspaceIdQueryV1();
    })

    watch(modelStrategyByWorkspaceIdQueryV1, (model) =>
    {
        const rm = model as StrategyReadModel

        if (!rm)
        {
            return
        }

        if (!isNullOrWhitespace(rm.DashboardUrl))
        {
            window.location.href = rm.DashboardUrl
            return
        }

        if (!invokingCreateStrategyCommandV1.value)
        {
            invokeCreateStrategyCommandV1()
        }
    })

    watch(errorCreateStrategyCommandV1, (err) =>
    {
        if (err)
        {
            console.error(err)
        }
    })

    watch(succeedCreateStrategyCommandV1, (succeeded) =>
    {
        if (succeeded)
        {
            window.location.reload();
        }
    })
</script>

<template>
    <div>
        {{workspaceId}}
    </div>
</template>


